import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }: { children: ReactJSXElement }) => {
  const token = localStorage.getItem("hipship-token");

  const location = useLocation();

  if (!token) {
    return (
      <Navigate
        to={"/login"}
        state={{ prevurl: location.pathname + location.search }}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
